import { FC, Fragment } from "preact/compat";
import { Transition } from "@headlessui/react";
import { useApp } from "~/core/store";
import { useDialogUrlState, usePortalTarget } from "~/hooks";
import navigation from "../navigation";
import MenuItem from "./MenuItem";
import LogoutIcon from "@material-design-icons/svg/outlined/logout.svg";

const MobileMenu: FC = () => {
    const { mobile, api } = useApp();
    const target = usePortalTarget();
    const user = api.connection.value?.user;
    const installation = api.installation.value;
    const company = api.company.value;

    useDialogUrlState(mobile.isMenuOpen, { noBack: true });

    if (!target.value) {
        return null;
    }

    const handleLogout = () => {
        window.location.href = "/p/login?prompt=force";
    };

    return (
        <Transition
            as={Fragment}
            show={mobile.isMenuOpen.value}
            enter="transform transition duration-100 ease-in"
            enterFrom="scale-105 opacity-0"
            enterTo="scale-100 opacity-100"
            leave="transform transition duration-100 ease-out"
            leaveFrom="scale-100 opacity-100"
            leaveTo="scale-105 opacity-0"
        >
            <div className="fixed left-2 top-[calc(46px+var(--safe-top))] z-[70] max-h-[80vh] w-[calc(100vw-74px)] select-none overflow-y-auto rounded-lg bg-[#335370] fill-current text-white shadow-lg">
                <div className="flex flex-col gap-y-1 px-4 py-4">
                    {navigation.mobile().map((props) => (
                        <MenuItem key={props.path} {...props} />
                    ))}
                    <div className="mt-8 flex items-center justify-between">
                        <div className="flex gap-x-4">
                            <img
                                src={user?.picture}
                                alt={user?.name}
                                width="40"
                                height="40"
                                className="min-w-10 rounded-full border-2 border-gray-100 object-cover shadow-inner-bold"
                            />
                            <div>
                                <h3>{user?.name}</h3>
                                <h4 className="text-sm">
                                    {user?.preferred_username}@{installation} (
                                    {company})
                                </h4>
                            </div>
                        </div>
                        <button
                            type="button"
                            title="Logout"
                            className="flex items-center rounded-full fill-current p-2"
                            onClick={handleLogout}
                        >
                            <LogoutIcon width="20" height="20" />
                        </button>
                    </div>
                </div>
            </div>
        </Transition>
    );
};

export default MobileMenu;
